import * as THREE from 'three';
import BaseMesh from './base-mesh';
import { HeatMapType } from '@blade-sxp/map/utils/styleType';
class HeatMap extends BaseMesh {
    static geometry = new THREE.PlaneGeometry(80, 80);
    static critical = HeatMap._draw(40, HeatMapType['critical'], 200, 'critical');
    static major = HeatMap._draw(40, HeatMapType['major'], 200, 'major');
    static minor = HeatMap._draw(40, HeatMapType['minor'], 200, 'minor');
    static normal = HeatMap._draw(40, HeatMapType['normal'], 200, 'normal');
    static complex = HeatMap._draw(40, HeatMapType['complex'], 200, 'complex');
    static material_critical = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        map: HeatMap.critical,
        transparent: true,
        depthTest: true,
        opacity: 1,
    });
    static material_major = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        map: HeatMap.major,
        transparent: true,
        depthTest: true,
        opacity: 1,
    });
    static material_minor = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        map: HeatMap.minor,
        transparent: true,
        depthTest: true,
        opacity: 1,
    });
    static material_normal = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        map: HeatMap.normal,
        transparent: true,
        depthTest: true,
        opacity: 1,
    });
    static material_complex = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        map: HeatMap.complex,
        transparent: true,
        depthTest: true,
        opacity: 1,
    });
    constructor(data) {
        super(data);
        const { position, renderProps } = this.props;
        this.position.set(position.x, position.y, position.z);
        const { colorStops, size = 0, rotateX = 0, type, radius } = renderProps;
        this.rotation.x = Math.PI * rotateX;
        this.isObserver = true;
        // this.geometry = new THREE.CircleGeometry(50, 32);
        if (Number(radius) !== 40) {
            // if (type === 'complex') {
            //   const img = new Image();
            //   img.src = pointTexture;
            //   img.onload = () => {
            //     this.geometry = new THREE.PlaneGeometry(radius * 2, radius * 2);
            //     this.material = new THREE.MeshBasicMaterial({
            //       side: THREE.DoubleSide,
            //       map: HeatMap._draw(radius, HeatMapType[type as 'normal'], 200, img),
            //       transparent: true,
            //       depthTest: true,
            //       opacity: 1,
            //     });
            //   };
            // } else {
            //   this.geometry = new THREE.PlaneGeometry(radius * 2, radius * 2);
            //   this.material = new THREE.MeshBasicMaterial({
            //     side: THREE.DoubleSide,
            //     map: HeatMap._draw(radius, HeatMapType[type as 'normal'], 200),
            //     transparent: true,
            //     depthTest: true,
            //     opacity: 1,
            //   });
            // }
            this.geometry = new THREE.PlaneGeometry(radius * 2, radius * 2);
            this.material = new THREE.MeshBasicMaterial({
                side: THREE.DoubleSide,
                map: HeatMap._draw(radius, HeatMapType[type], 200, type),
                transparent: true,
                depthTest: true,
                opacity: 1,
            });
        }
        else {
            this.geometry = HeatMap.geometry;
            this.material = HeatMap[`material_${type}`];
        }
        // this.material = new THREE.PointsMaterial({
        //   // map: this._draw(radius, width, height, colorStops, size),
        //   side: THREE.DoubleSide,
        //   color: 'red',
        //   transparent: true,
        //   depthTest: true,
        //   opacity: 1,
        // });
    }
    update(data) {
        const { position, renderProps } = data;
        const { type, colorStops, size } = renderProps;
        this.position.set(position.x, position.y, position.z);
        if (type !== this.props?.renderProps?.type) {
            this.material = HeatMap[`material_${type}`];
        }
        super.update(data);
    }
    onClick() {
        super.onClick();
    }
    static getMaxMin(value) {
        let min = Number.MAX_SAFE_INTEGER;
        let max = -Number.MAX_SAFE_INTEGER;
        min = Math.min(min, value);
        max = Math.max(max, value);
        return { max, min };
    }
    static _draw(radius, colorStops, size, type) {
        const canvas = document.createElement('canvas');
        canvas.width = radius * 2;
        canvas.height = radius * 2;
        const context = canvas.getContext('2d');
        if (context) {
            context.beginPath();
            context.arc(radius, radius, radius, 0, 2 * Math.PI);
            context.closePath();
            // 创建渐变色: r,g,b取值比较自由，我们只关注alpha的数值
            const radialGradient = context.createRadialGradient(radius, radius, 0, radius, radius, radius);
            // 添加一个由偏移值和颜色值指定的断点到渐变
            // radialGradient.addColorStop(1.0, "#FF000000");
            colorStops.forEach(({ offset, color }) => {
                radialGradient.addColorStop(offset, color);
            });
            context.fillStyle = radialGradient;
            const { max, min } = this.getMaxMin(size);
            // 设置globalAlpha: 需注意取值需规范在0-1之间
            const globalAlpha = (size - min) / (max - min);
            context.globalAlpha = Math.max(Math.min(globalAlpha, 1), 0);
            // if (type === 'complex') {
            //   const img = new Image();
            //   const pointTexture = require('@blade-sxp/map/src/assets/1111111.svg');
            //   img.src = pointTexture;
            //   img.style.width = '9px';
            //   img.style.height = '9px';
            //   img.onload = (e) => {
            //     console.log(12312, e);
            //     const pattern = context.createPattern(img, 'repeat') as CanvasPattern;
            //     context.fillStyle = pattern;
            //     context.fill();
            //   };
            // }
            // 填充颜色
            context.fill();
        }
        const canvasTexture = new THREE.CanvasTexture(canvas);
        // canvasTexture.minFilter = THREE.NearestFilter;
        // canvasTexture.magFilter = THREE.NearestFilter;
        canvasTexture.needsUpdate = true;
        return canvasTexture;
    }
    dispose() {
        const { onDestory } = this.props;
        this.parent?.remove(this);
        this.material.dispose();
        this.geometry.dispose();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default HeatMap;
